BaseModel = require './base_model.coffee'

class global.RdStationSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    authorized: {}
    mark_lead_as_sale: {}
    mark_lead_as_lost: {}
    mark_lead_as_opportunity: {}
    triggers: { default: { on_created: false, status: [], stages: [] }, type: Object }
    use_carousel: { default: false }
    use_carousel_by_property: { default: true}
    custom_field_id: {}
    original_response: {}
    properties_matching: { default: [], type: Array }
  }



// WEBPACK FOOTER //
// ./src/models/rd_station_setting.coffee